declare namespace $ {

	type $shm_hitalama_tabulator__columns_shm_hitalama_map_widget_float_tabulator_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_tabulator['columns'] >
		,
		ReturnType< $shm_hitalama_tabulator['columns'] >
	>
	type $shm_hitalama_tabulator__data_shm_hitalama_map_widget_float_tabulator_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_tabulator['data'] >
		,
		ReturnType< $shm_hitalama_tabulator['data'] >
	>
	type $shm_hitalama_tabulator__options_shm_hitalama_map_widget_float_tabulator_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_tabulator['options'] >
		,
		ReturnType< $shm_hitalama_tabulator['options'] >
	>
	type $mol_button_minor__title_shm_hitalama_map_widget_float_tabulator_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_widget_float_tabulator_5 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_tabulator['echarts_add'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_shm_hitalama_map_widget_float_tabulator_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_widget_float_tabulator_7 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_tabulator['settings_add'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	export class $shm_hitalama_map_widget_float_tabulator extends $shm_hitalama_map_widget_float {
		columns( ): readonly(any)[]
		data( ): readonly(any)[]
		options( ): any
		Tabulator( ): $shm_hitalama_tabulator
		echarts_add( next?: any ): any
		Echarts_add( ): $mol_button_minor
		settings_add( next?: any ): any
		Settings_add( ): $mol_button_minor
		controls( ): readonly(any)[]
		width_min( ): number
		height_min( ): number
		contextmenu_body( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=tabulator.view.tree.d.ts.map